import cn from 'classnames'
import {FC} from 'react'

import {SWITCHER_TRANSITION} from '@/theme/cssTransitions'
import {MIN_TARGET_SIZE} from '@/theme/sizing'
import {theme} from '@/theme/theme'

type SwitcherProps = {
  isAllowed: boolean
  onChange: (isAllowed: boolean) => void
  dotSize?: number
  isDisabled?: boolean
  ariaLabel?: string
}

export const Switcher: FC<SwitcherProps> = ({
  isAllowed,
  onChange,
  dotSize = 14,
  isDisabled = false,
  ariaLabel,
}) => {
  const padding = dotSize / 6
  const height = dotSize + padding * 2
  const width = height * 2
  const targetPadding = Math.max(0, (MIN_TARGET_SIZE - height) / 2)

  return (
    <>
      <label className={cn(isDisabled && 'disabled')}>
        <input
          type="checkbox"
          onChange={() => onChange(!isAllowed)}
          value={isAllowed.toString()}
          disabled={isDisabled}
          aria-label={ariaLabel}
        />
        <div className={cn('switch', isAllowed && 'allowed')} />
      </label>

      <style jsx>{`
        label {
          display: block;
          padding: ${targetPadding}px 0;
          margin: -${targetPadding}px 0;
        }
        input {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }
        .disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        .switch {
          position: relative;
          width: ${width}px;
          height: ${height}px;
          border-radius: ${height}px;
          background-color: ${theme.palette.gray[400]};
          cursor: pointer;
          transition: ${SWITCHER_TRANSITION}ms ease-in-out;
        }
        .switch::before {
          position: absolute;
          content: '';
          height: ${dotSize}px;
          width: ${dotSize}px;
          left: ${padding}px;
          bottom: ${padding}px;
          background-color: ${theme.palette.background.default};
          border-radius: 50%;
          transition: ${SWITCHER_TRANSITION}ms ease-in-out;
        }
        .allowed {
          background-color: ${theme.palette.success.main};
        }
        .allowed::before {
          transform: translateX(${height}px);
        }
      `}</style>
    </>
  )
}
